module.exports = __webpack_public_path__ + "img/coolguy_ios_802.png";